export default __webpack_public_path__ + "static/media/overview.84b10c97.jpeg";